var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"magtop60"},[_c('div',{staticClass:"msg_box",domProps:{"innerHTML":_vm._s(_vm.th)}})])}
var staticRenderFns = []

export { render, staticRenderFns }